import axios from '@/axios.js'

let entityURL = 'groups'; // variant depending on entity URLs
let token = localStorage.getItem('accessToken');
let apiEndpoint = localStorage.getItem('apiEndpoint');
axios.defaults.baseURL = apiEndpoint;
axios.defaults.headers.common = { 'Authorization': `bearer ${token}` }

const state = {
    groups: [],
    group: {},
    displayGroupPopUp: false,
    displayGroupPopUpTitle: '',
}

const getters = {
    getGroups: (state) => (state.groups),
    getGroup: (state) => (state.group),
    getDisplayGroupPopUp: (state) => (state.displayGroupPopUp),
    getDisplayGroupPopUpTitle: (state) => (state.displayGroupPopUpTitle),
}

const actions = {
    // Add new group
    async addNewGroup({ commit }, group) {
        const response = await axios.post(`${entityURL}/add`, group)
        commit('ADD_NEW_GROUP', response.data.object)
    },

    // Fetch Groups
    async fetchGroups({ commit }) {
        const response = await axios(`${entityURL}/list`)
        commit('SET_GROUPS', response.data)
    },

    // Fetch Group
    async fetchGroup({ commit }, payloadId) {
        const response = await axios(`${entityURL}/get/${payloadId}`)
        commit('SET_GROUP', response.data)
    },

    // Update Group
    async updateGroup({ commit }, payload) {
        const response = await axios.put(`${entityURL}/update/${payload.id}`, payload)
        commit('UPDATE_GROUP', response.data.object)
    },

    // Delete Group
    async deleteGroup({ commit }, payloadId) {
        const response = await axios.delete(`${entityURL}/delete/${payloadId}`)
        if (response.data.message === 'Successfully Deleted') {
            commit('DELETE_GROUP', payloadId)
        }
    },

    // Toggle group pop up
    toggleGroupPopUp({ commit }, value) {
        commit('TOGGLE_GROUP_POP_UP', value)
    },

    // Set group pop up title
    setGroupPopUpTitle({ commit }, value) {
        commit('SET_GROUP_POP_UP_TITLE', value)
    },

    // Set Group
    setGroup({ commit }, payload) {
        commit('SET_GROUP', payload)
    },

    // Name setter
    groupNameSetter({ commit }, value) {
        commit('GROUP_NAME_SETTER', value)
    },

    groupEmailSetter({ commit }, value) {
        commit('GROUP_EMAIL_SETTER', value)
    },

    groupSendOnlyChangesSetter({ commit }, value) {
        commit('GROUP_SEND_ONLY_CHANGES_SETTER', value)
    },
    groupSendMassiveEmailSetter({ commit }, value) {
        commit('GROUND_SEND_MASSIVE_EMAIL_SETTER', value)
    }

}

const mutations = {
    ADD_NEW_GROUP: (state, data) => (state.groups.push(data)),
    SET_GROUPS: (state, data) => (state.groups = data),
    SET_GROUP: (state, data) => (state.group = data),
    UPDATE_GROUP: (state, data) => {
        const groupIndex = state.groups.findIndex(x => x.id === data.id)
        if (groupIndex !== -1) {
            state.groups.splice(groupIndex, 1, data)
            state.group = data
        }
    },
    DELETE_GROUP: (state, data) => {
        const groupIndex = state.groups.findIndex(x => x.id === data)
        if (groupIndex !== -1) {
            state.groups.splice(groupIndex, 1)
        }
    },
    TOGGLE_GROUP_POP_UP: (state, value) => (state.displayGroupPopUp = value),
    SET_GROUP_POP_UP_TITLE: (state, value) => (state.displayGroupPopUpTitle = value),
    GROUP_NAME_SETTER: (state, value) => (state.group.name = value),
    GROUP_EMAIL_SETTER: (state, value) => (state.group.email = value),
    GROUP_SEND_ONLY_CHANGES_SETTER: (state, value) => (state.group.sendOnlyChanges = value),
    GROUND_SEND_MASSIVE_EMAIL_SETTER: (state, value) => (state.group.sendMassiveEmail = value)
}

export default { state, getters, actions, mutations }